import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { useBackToList } from '@/components/app/use-back-to-list'
import { OrderProjectContainer } from '@/components/screens/order-line-matching/project-containers'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_line_matching/projects/$project_key')({ component: Page })
function Page() {
  const { tenant_id: tenantId, project_key: projectKey } = Route.useParams()
  const me = useMe()
  const navigate = useNavigate()
  const backToList = useBackToList(() => {
    void navigate({ to: '/t/$tenant_id/order_line_matching', params: { tenant_id: tenantId } })
  })
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        {me.tenant.setting?.orderLineMatchingEnabled === true ? (
          <OrderProjectContainer
            onBack={backToList}
            onDeletedOrder={() => {
              void navigate({ to: '/t/$tenant_id/order_line_matching', params: { tenant_id: tenantId } })
            }}
            onRenamedProject={(newProjectKey) => {
              void navigate({
                to: '/t/$tenant_id/order_line_matching/projects/$project_key',
                params: { tenant_id: tenantId, project_key: newProjectKey },
              })
            }}
            onEditOrder={(orderId) => {
              void navigate({
                to: '/t/$tenant_id/order_line_matching/orders/$order_id',
                params: { tenant_id: tenantId, order_id: orderId },
                search: { project: projectKey },
              })
            }}
            key={JSON.stringify([tenantId, projectKey])}
            projectKey={projectKey}
            tenantId={tenantId}
            canEdit
          />
        ) : (
          <ErrorPanel
            layout="section"
            title="発注明細照合機能が有効になっていません"
            description="ご利用を希望する場合は運営までお問い合わせください。"
          />
        )}
      </main>
    </div>
  )
}
